module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/icon-marketing-lg-706b6bcc1ea66ece63020840242b33f7.png";